import React, { useEffect, useState } from 'react';
import Button from '../Button/Button';
import classnames from 'classnames';
import IconArrowUp from './files/arrow-up.svg';

const BackToTop = () => {
  const [showScroll, setShowScroll] = useState(false);
  const wrapperClasses = classnames('back-to-top__wrapper', {
    showScroll,
  });

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      setShowScroll(false);
    }, 1000);
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop);
    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, []);

  return (
    <div className={wrapperClasses}>
      <Button className="back-to-top footer__link" onClick={scrollTop}>
        <span className="back-to-top__text">Back to top</span>
        <IconArrowUp
          className="back-to-top__icon"
          aria-hidden="true"
          focusable={false}
        />
      </Button>
    </div>
  );
};

export default BackToTop;
